export default __webpack_public_path__ + "assets/landing-page-4.jpg";